import '@shared/library/dist/styles/index.scss';
import '@shared/library/dist/styles/lib.scss';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import WebGest from './components/WebGest';
import config from './config';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter basename={config.app.location}>
    <WebGest />
  </BrowserRouter>
);